import { ToolbarElement } from './ToolbarElement'

export class ToolbarButtonElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  constructor(overlayContainer: HTMLDivElement, public readonly name: string) {
    super(overlayContainer)
    this.initDom()
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-button-${this.name}`, 'toolbar-button')
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.entryElement.addEventListener('click', () => {
      this.emit(`click`)
    })
  }
}
